/* eslint-disable camelcase */
import React, { Component } from 'react';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import SVGComponent from '../../components/SVG/SVGComponent';
import { PERMISSIONS, SVG_ICONS } from '../../constants';

class AvailablePlayersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmationModalOpen: false,
      selectedPlayer: null,
    };
  }

  promptConfirmationToRemovePlayer = (playerId) => {
    const selectedPlayer = this.props.playersList?.find((player) => player?.id === playerId);
    this.setState({
      confirmationModalOpen: !this.state.confirmationModalOpen,
      playerId,
      selectedPlayer,
    });
  };

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false,
      selectedPlayer: null,
    });
  };

  removePlayerConfirmation = () => {
    this.props.disablePlayer(this.state.selectedPlayer?.id);
    this.closeConfirmationModal();
  };

  render() {
    return (
      <>
        <div className="team-section__player-list">
          {this.props.playersList?.map((player) => (

            <div className="team-section__player" key={player?.id}>
              <span>{`${player?.name} (${player?.reference_name ? player?.reference_name : ''})`}</span>
              {this.props.checkPermisson(PERMISSIONS.GOALSCORER_PLAYERS_DISABLE)
              && !this.props.editDisabled
                ? (
                  <div
                    className="team-section__player-del"
                    onClick={this.promptConfirmationToRemovePlayer.bind(this.state, player?.id)}
                    disabled={(player?.squad_position !== 0 && player?.squad_position !== null)}
                  >
                    <SVGComponent
                      className="icon-xxs"
                      src={`${SVG_ICONS.utility}#bin`}
                    />
                  </div>
                )
                : null}
            </div>

          ))}

        </div>

        {this.state.confirmationModalOpen ? (
          <>
            <div className="modal modal--open">
              <ConfirmationModal
                modalData={{
                  heading: 'Remove Player',
                  title: 'Are you sure you want to remove: ',
                  additionalMessages: [this.state.selectedPlayer?.name],
                }}
                cancel={this.closeConfirmationModal}
                confirmation={this.removePlayerConfirmation}
              />
            </div>
            <div className="overlay-mask overlay-mask--open" />
          </>
        ) : null}

      </>
    );
  }
}

export default AvailablePlayersList;
